import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { connect } from "react-redux";
import moment from 'moment';

import { Panel, PanelBody, PanelHeader } from "../../header/panel/panel"

import { processorTerminalHeadings, tableHeadings } from '../../../utils/constants';

import { fetchProcessorTerminal, fetchCassetteData, setProcessorTerminalID, resetProcessorTerminalSessionKey, setKeysData, updateProcessorTermSeq, setClone, fetchTerminalBatchData } from '../../../redux/actions/ProcessorTerminalActions';
import { setMerchantID } from '../../../redux/actions/MerchantActions';

import { fetchMerchantProcessorTerminals } from '../../../redux/actions/DropdownActions';


import TableView from '../Table/Table';

import ProcessorTerminalBatchList from './ProcessorTerminalBatchList';
import ProcessorTerminalCassette from './ProcessorTerminalCassette'

// import ProcessorTerminalKeys from './ProcessorTerminalKeys';
import { fetchProcessorTerminalTransactions } from '../../../redux/actions/TransactionActions';
import { setTerminalID } from '../../../redux/actions/TerminalActions';


const ProcessorTerminalProfile = (props) => {

    const navigate = useNavigate();

    const [, setAddModelOpen] = useState(false)

    const [isoValue, setIsoValue] = useState('');
    const [merchantID, setMerchantID] = useState('')
    const [processorTermID, setProcessorTermID] = useState('');
    const [processorTermIDEntered, setProcessorTermIDEntered] = useState('')

    const [merchantDropdown, setMerchantDropdown] = useState([])
    const [processorTerminalDropdown, setProcessorTerminalDropdown] = useState([])


    const heading = processorTerminalHeadings;

    useEffect(() => {

        let id = props.PROCESSORTERMINALREDUCER.processorTerminalID

        console.log('Processor Term Id ' + id)

        if (id) {
            props.fetchCassetteData(id)
            props.fetchProcessorTerminal(id)
            console.log(props.PROCESSORTERMINALREDUCER.processorTerminalData[0])
            props.fetchProcessorTerminalTransactions(id)

        } else {
            handleBackToList();
        }

    }, [])

    const handleAddKey = () => {
        props.setKeysData([])
        setAddModelOpen(true)

    }

    const handleUpdateSeq = () => {
        props.updateProcessorTermSeq(props.PROCESSORTERMINALREDUCER.processorTerminalID)
    }

    const handleBackToList = () => {
        navigate('/processorTerminals/list')
    }

    const handleEditClick = () => {
        navigate('/processorTerminal/edit')
    }

    const handleResetSessionKey = (event) => {

        event.preventDefault();

        let body = {}
        body.processorTermID = props.PROCESSORTERMINALREDUCER.processorTerminalID


        console.log('Resetting session key - : ' + body)
        if (body.processorTermID) {
            props.resetProcessorTerminalSessionKey(body)
        }

    }

    const handleClone = () => {
        props.setClone(true)
        navigate('/processorTerminal/add')
    }

    const handleGroupView = () => {

    }

    const handleTerminalIDclick = () => {
        if (props.PROCESSORTERMINALREDUCER.processorTerminalData[0]?.groupID && props.PROCESSORTERMINALREDUCER.processorTerminalData[0]?.groupID !== 'null') {
            props.setTerminalID(props.PROCESSORTERMINALREDUCER.processorTerminalData[0]?.groupID)
            console.log('PTID ' + props.PROCESSORTERMINALREDUCER.processorTerminalData[0]?.groupID)
            navigate('/terminal/view')
        } else {
        }

    }

    const handleMerchantClick = () => {
        props.setMerchantID(props.PROCESSORTERMINALREDUCER.processorTerminalData[0].merchantID)
        navigate('/merchant/view')
    }

    const handleTerminalSelect = () => {

        let id = processorTermID ? processorTermID : processorTermIDEntered;

        if (id) {
            props.fetchCassetteData(id)
            props.setProcessorTerminalID(id)
            props.fetchProcessorTerminal(id)
            console.log(props.PROCESSORTERMINALREDUCER.processorTerminalData[0])
            props.fetchProcessorTerminalTransactions(id)
            props.fetchTerminalBatchData(id)
        }

    }

    const handleChange = (event) => {
        let targetName = event.target.name
        let targetValue = event.target.value

        switch (targetName) {

            case 'isoID':
                if (targetValue) {
                    setIsoValue(targetValue);
                    let merchants = props.DROPDOWNREDUCER.isosData.filter(iso => {
                        // eslint-fix: preserve loose-equality coercion
                        return String(iso.isoID) === String(targetValue)
                    })

                    // eslint-fix: preserve loose-equality coercion
                    if (Number(props.LOGINREDUCER.USER.role) === 1 || Number(props.LOGINREDUCER.USER.role) === 2 || Number(props.LOGINREDUCER.USER.role) === 6) {
                        console.log(merchants[0]?.merchants)
                        setMerchantDropdown(merchants[0]?.merchants)

                        console.log('merchant drop : ' + merchantDropdown)
                    } else {
                        setMerchantDropdown(merchants[0]?.merchants)
                    }
                }
                break;

            case 'merchantID':
                if (targetValue) {
                    setMerchantID(targetValue)
                    props.fetchMerchantProcessorTerminals(targetValue)
                }
            // falls through
            case 'processorTermID':
                setProcessorTermID(targetValue)
                setProcessorTermIDEntered('')
                break;

            case 'processorTermIDEntered':
                setProcessorTermIDEntered(targetValue)
                setProcessorTermID('')
                setIsoValue('');
                setMerchantID('')
                break;

            default:
                break;
        }
    }

    const handleTerminalDrop = () => {

        console.log('Data : ' + props.DROPDOWNREDUCER.merchantProcessorTerminals)

        if (props.DROPDOWNREDUCER.merchantProcessorTerminals && props.DROPDOWNREDUCER.merchantProcessorTerminals?.length) {
            setProcessorTerminalDropdown(props.DROPDOWNREDUCER.merchantProcessorTerminals)
            console.log('Processor Dropdown ', processorTerminalDropdown)
        } else {
            setProcessorTerminalDropdown([])
        }
    }


    let SELECT_SECTION = (
        <Panel>

            <PanelBody>

                <div className="row mb-3">
                    <div className="col-xl-2">
                        <select className="form-select"
                            value={isoValue ? isoValue : ''}
                            onChange={handleChange}
                            name='isoID'
                        >
                            <option value=''>Select ISO</option>

                            {props.DROPDOWNREDUCER.isosData.map((option) => (
                                <option key={option.isoID} value={option.isoID}>
                                    {option.isoName}
                                </option>
                            ))}

                        </select>
                    </div>

                    <div className="col-xl-2">
                        <select className="form-select"
                            value={merchantID ? merchantID : ''}
                            onChange={handleChange}
                            name='merchantID'
                            onBlur={handleTerminalDrop}

                        >

                            <option value=''>Select Merchant</option>
                            {merchantDropdown.map((option) => (
                                <option key={option.merchantID} value={option.merchantID}>
                                    {option.merchantName}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div className="col-xl-2">
                        <select className="form-select"
                            value={processorTermID ? processorTermID : ''}
                            onChange={handleChange}
                            name='processorTermID'
                        >
                            <option value=''>Select Terminal</option>
                            {processorTerminalDropdown.map((option) => (
                                <option key={option.processorTermID} value={option.processorTermID}>
                                    {option.processorTermID}
                                </option>
                            ))}

                        </select>
                    </div>
                    <div className="col-sm-1"><b>OR Enter</b></div>

                    <div className="col-xl-2">
                        <input type="text"
                            className="form-control"
                            placeholder="Enter Processor Terminal ID  here"
                            name="processorTermIDEntered"
                            value={processorTermIDEntered ? processorTermIDEntered : ''}
                            onChange={handleChange} />

                    </div>

                    <div className="col-xl-2">

                        <button className="btn btn-gray w-100px me-5px" onClick={handleTerminalSelect}>View</button>
                    </div>
                </div>


            </PanelBody>

        </Panel>


    )



    return (

        <div>

            <div className="row mb-6">

                {/* eslint-fix: preserve loose-equality coercion */}
                {Number(props.LOGINREDUCER.USER.role) === 1 || Number(props.LOGINREDUCER.USER.role) === 6 ?
                    <div className="col-xl-12">
                        {SELECT_SECTION}
                    </div>
                    : null}
                <hr className="mb-10px bg-gray-600" />

                <div className="col-xl-5">

                    <Panel>

                        <PanelHeader>

                            <div className="row mb-0">

                                <div className="col-xl-8">
                                    Processor Terminal Profile
                                </div>

                                <div className="col-xl-2">
                                    <botton className='btn btn-secondary d-block w-30 btn-xs h-9px fs-11px'>
                                        <i className="icon-share-alt" onClick={handleClone}></i>
                                    </botton>
                                </div>

                                <div className="col-xl-2">
                                    {/* eslint-fix: preserve loose-equality coercion */}
                                    {Number(props.LOGINREDUCER.USER.role) === 1 || Number(props.LOGINREDUCER.USER.role) === 6 ? <button className='btn btn-secondary d-block w-30 btn-xs h-9px fs-11px' onClick={handleEditClick}>Edit</button> : null}

                                </div>

                            </div>

                        </PanelHeader>

                        <PanelBody>

                            <div className="table-responsive">

                                <table className="table mb-0">

                                    <tbody>

                                        {props.PROCESSORTERMINALREDUCER.processorTerminalData && props.PROCESSORTERMINALREDUCER.processorTerminalData.length ? Object.keys(heading).map(data => {

                                            let keyData = data.includes('processorModelsEntity') ? data.split(".") : data


                                            if (typeof (keyData) !== 'object') {

                                                switch (keyData) {

                                                    case 'merchantName':
                                                        return (
                                                            <tr key={keyData}>
                                                                <th style={{ width: '40%' }}>{heading[data]}</th>
                                                                <th>:</th>
                                                                <td>
                                                                    {/* eslint-fix: preserve loose-equality coercion */}
                                                                    {Number(props.LOGINREDUCER.USER.role) === 1 || Number(props.LOGINREDUCER.USER.role) === 6 ? <button size='small' onClick={handleMerchantClick}><b>{props.PROCESSORTERMINALREDUCER.processorTerminalData[0] && Object.keys(props.PROCESSORTERMINALREDUCER.processorTerminalData[0]).includes(data) && (props.PROCESSORTERMINALREDUCER.processorTerminalData[0][data] !== null && props.PROCESSORTERMINALREDUCER.processorTerminalData[0][data] !== undefined) ? props.PROCESSORTERMINALREDUCER.processorTerminalData[0][data] : '-'} </b></button> : props.PROCESSORTERMINALREDUCER.processorTerminalData[0][data]}
                                                                </td>
                                                            </tr>
                                                        )
                                                    case 'lastUpdated':
                                                    case 'createDate':
                                                        return (
                                                            <tr key={keyData}>
                                                                <th style={{ width: '38%' }}>{heading[keyData]}</th>
                                                                <th>:</th>
                                                                <td>{props.PROCESSORTERMINALREDUCER.processorTerminalData[0] && Object.keys(props.PROCESSORTERMINALREDUCER.processorTerminalData[0]).includes(keyData) ? moment(props.PROCESSORTERMINALREDUCER.processorTerminalData[0][keyData]).format('MMM DD, YYYY hh:mm:ss A') : '-'}
                                                                </td>
                                                            </tr>
                                                        )
                                                    case 'processorID':
                                                        let processor = props.DROPDOWNREDUCER.processorsData.filter(processor => {
                                                            // eslint-fix: preserve loose-equality coercion
                                                            return String(processor.processorID) === String(props.PROCESSORTERMINALREDUCER.processorTerminalData[0][data])
                                                        })
                                                        return (
                                                            <tr key={keyData}>
                                                                <th style={{ width: '38%' }}>{heading[data]}</th>
                                                                <th>:</th>
                                                                <td>{props.PROCESSORTERMINALREDUCER.processorTerminalData[0] && Object.keys(props.PROCESSORTERMINALREDUCER.processorTerminalData[0]).includes(data) ? processor[0].processorName : '-'}
                                                                </td>
                                                            </tr>

                                                        )
                                                    case 'sessionKeyLastUpdated':
                                                        return (
                                                            <tr key={keyData}>
                                                                <th style={{ width: '38%' }}>{heading[keyData]}</th>
                                                                <th>:</th>
                                                                <td>
                                                                    {props.PROCESSORTERMINALREDUCER.processorTerminalData[0] && Object.keys(props.PROCESSORTERMINALREDUCER.processorTerminalData[0]).includes(keyData) && props.PROCESSORTERMINALREDUCER.processorTerminalData[0][keyData] != null ? moment(props.PROCESSORTERMINALREDUCER.processorTerminalData[0][keyData]).format('MMM DD, YYYY hh:mm:ss A') : 'No Session key'}
                                                                    &nbsp;&nbsp;
                                                                    <button onClick={handleResetSessionKey}>Reset Key</button>

                                                                </td>
                                                            </tr>
                                                        )
                                                    case 'multipleTID':
                                                        return (
                                                            <tr key={keyData}>
                                                                <th style={{ width: '40%' }}>{heading[data]}</th>
                                                                <th>:</th>
                                                                <td>
                                                                    {(props.PROCESSORTERMINALREDUCER.processorTerminalData[0]?.multipleTID) ?
                                                                        <button variant='text' size='small' onClick={handleGroupView}><b>{props.PROCESSORTERMINALREDUCER.processorTerminalData[0]?.groupName !== 'null' ? props.PROCESSORTERMINALREDUCER.processorTerminalData[0]?.groupName !== 'null' : 'Not Assigned'} </b></button>
                                                                        :
                                                                        <button variant='text' size='small' onClick={handleTerminalIDclick}><b>{(props.PROCESSORTERMINALREDUCER.processorTerminalData[0]?.groupID !== 'null') ? props.PROCESSORTERMINALREDUCER.processorTerminalData[0]?.groupID : 'Assign'} </b></button>
                                                                    }
                                                                </td>
                                                            </tr>
                                                        )
                                                    case 'lastProcessedSeqNum':
                                                        return (
                                                            <tr key={keyData}>
                                                                <th style={{ width: '38%' }}>{heading[keyData]}</th>
                                                                <th>:</th>
                                                                <td>
                                                                    {props.PROCESSORTERMINALREDUCER.processorTerminalData[0] && Object.keys(props.PROCESSORTERMINALREDUCER.processorTerminalData[0]).includes(keyData) && props.PROCESSORTERMINALREDUCER.processorTerminalData[0][keyData] !== 'null' ? props.PROCESSORTERMINALREDUCER.processorTerminalData[0][keyData] : 'N/A'}
                                                                    &nbsp;&nbsp;
                                                                    <button variant='contained' size='small' onClick={handleUpdateSeq}>Update Seq Num</button>

                                                                </td>
                                                            </tr>
                                                        )
                                                    case 'checkDigit':
                                                        return (
                                                            <tr key={keyData}>
                                                                <th style={{ width: '38%' }}>{heading[keyData]}</th>
                                                                <th>:</th>
                                                                <td>
                                                                    {props.PROCESSORTERMINALREDUCER.processorTerminalData[0] && Object.keys(props.PROCESSORTERMINALREDUCER.processorTerminalData[0]).includes(keyData) && props.PROCESSORTERMINALREDUCER.processorTerminalData[0][keyData] !== 'null' ? props.PROCESSORTERMINALREDUCER.processorTerminalData[0][keyData] : 'No Key Added'}
                                                                    &nbsp;&nbsp;
                                                                    <button variant='contained' size='small' onClick={handleAddKey}>Add Key</button>

                                                                </td>
                                                            </tr>
                                                        )
                                                    case 'processorTermStatusID':
                                                        return (
                                                            <tr key={keyData}>
                                                                <th style={{ width: '38%' }}>{heading[keyData]}</th>
                                                                <th>:</th>
                                                                {/* eslint-fix: preserve loose-equality coercion */}
                                                            <td className={Number(props.PROCESSORTERMINALREDUCER.processorTerminalData[0][keyData]) === 1 ? 'approved' : Number(props.PROCESSORTERMINALREDUCER.processorTerminalData[0][keyData]) === 2 ? 'suspended' : Number(props.PROCESSORTERMINALREDUCER.processorTerminalData[0][keyData]) === 3 ? 'inactive' : 'approved'}>{props.PROCESSORTERMINALREDUCER.processorTerminalData[0] && Object.keys(props.PROCESSORTERMINALREDUCER.processorTerminalData[0]).includes(keyData) ? Number(props.PROCESSORTERMINALREDUCER.processorTerminalData[0][keyData]) === 1 ? 'Active' : Number(props.PROCESSORTERMINALREDUCER.processorTerminalData[0][keyData]) === 2 ? 'Suspended' : Number(props.PROCESSORTERMINALREDUCER.processorTerminalData[0][keyData]) === 3 ? 'InActive' : 'Deleted' : '-'}
                                                                </td>
                                                            </tr>
                                                        )
                                                    case 'autoBatch':
                                                        return (
                                                            <tr key={keyData}>
                                                                <th style={{ width: '38%' }}>{heading[keyData]}</th>
                                                                <th>:</th>
                                                                {/* eslint-fix: preserve loose-equality coercion */}
                                                            <td >{props.PROCESSORTERMINALREDUCER.processorTerminalData[0] && Object.keys(props.PROCESSORTERMINALREDUCER.processorTerminalData[0]).includes(keyData) ? (Number(props.PROCESSORTERMINALREDUCER?.processorTerminalData[0][keyData]) === 1 ?
                                                                    'Yes ' : 'No') : '-'}
                                                                </td>
                                                            </tr>
                                                        )

                                                    case 'settlementDelay':
                                                        // Only admins (role 1) can see settlement delay
                                                        if (Number(props.LOGINREDUCER.USER.role) !== 1) {
                                                            return null
                                                        }
                                                        return (
                                                            <tr key={keyData}>
                                                                <th style={{ width: '38%' }}>{heading[keyData]}</th>
                                                                <th>:</th>
                                                                <td>{props.PROCESSORTERMINALREDUCER.processorTerminalData[0] && Object.keys(props.PROCESSORTERMINALREDUCER.processorTerminalData[0]).includes(keyData) && props.PROCESSORTERMINALREDUCER.processorTerminalData[0][keyData] !== null && props.PROCESSORTERMINALREDUCER.processorTerminalData[0][keyData] !== undefined ? props.PROCESSORTERMINALREDUCER.processorTerminalData[0][keyData] : '-'}
                                                                </td>
                                                            </tr>
                                                        )
                                                    case 'timeZone':
                                                        return (
                                                            <tr key={data}>
                                                                <th style={{ width: '38%' }}>{heading[keyData]}</th>
                                                                <th>:</th>
                                                                <td>{props.PROCESSORTERMINALREDUCER.processorTerminalData[0] && Object.keys(props.PROCESSORTERMINALREDUCER.processorTerminalsData[0]).includes(keyData) ? props.PROCESSORTERMINALREDUCER.processorTerminalsData[0][keyData].substring(0, 3) : '-'}
                                                                </td>
                                                            </tr>
                                                        )
                                                    default:
                                                        return (
                                                            <tr key={keyData}>
                                                                <th style={{ width: '38%' }}>{heading[keyData]}</th>
                                                                <th>:</th>
                                                                <td>{props.PROCESSORTERMINALREDUCER.processorTerminalData[0] && Object.keys(props.PROCESSORTERMINALREDUCER.processorTerminalData[0]).includes(keyData) && props.PROCESSORTERMINALREDUCER.processorTerminalData[0][keyData] !== 'null' ? props.PROCESSORTERMINALREDUCER.processorTerminalData[0][keyData] : '-'}
                                                                </td>
                                                            </tr>

                                                        )
                                                }
                                            } else {
                                                if (props.PROCESSORTERMINALREDUCER.processorTerminalData[0][keyData[0]][keyData[1]]) {
                                                    return (
                                                        <tr key={keyData}>
                                                            <th style={{ width: '38%' }}>{heading[data]}</th>
                                                            <th>:</th>
                                                            <td>{props.PROCESSORTERMINALREDUCER.processorTerminalData[0][keyData[0]][keyData[1]] && (props.PROCESSORTERMINALREDUCER.processorTerminalData[0][keyData[0]][keyData[1]] !== null && props.PROCESSORTERMINALREDUCER.processorTerminalData[0][keyData[0]][keyData[1]] !== undefined) ? props.PROCESSORTERMINALREDUCER.processorTerminalData[0][keyData[0]][keyData[1]] : '-'}
                                                            </td>
                                                        </tr>
                                                    )
                                                }
                                                return null

                                            }
                                        }) : null}
                                    </tbody>
                                </table>
                            </div>
                        </PanelBody>

                    </Panel>
                </div>
                <div className="col-xl-7">
                    <div className="row mb-6">

                        <div className="col-xl-12">

                            <ProcessorTerminalBatchList processorTermID={props.PROCESSORTERMINALREDUCER.processorTerminalID} />
                        </div>
                        <div className="col-xl-12">
                            <ProcessorTerminalCassette processorTermID={props.PROCESSORTERMINALREDUCER.processorTerminalID}></ProcessorTerminalCassette>

                        </div>

                    </div>

                </div>

                <div className="col-xl-12">
                    <Panel>
                        <PanelHeader>
                            <b>
                                RECENT TRANSACTIONS
                            </b>
                        </PanelHeader>

                        <TableView height={643} count={14} headings={tableHeadings.processorTerminalTransactions} data={props.TRANSACTIONREDUCER.transactionsData} />
                    </Panel>
                </div>

            </div>
        </div>

    )

}

function mapStateToProps(state) {
    return state
}

const mapDispatchToProps = {
    fetchProcessorTerminal,
    fetchProcessorTerminalTransactions,
    resetProcessorTerminalSessionKey,
    fetchCassetteData,
    fetchMerchantProcessorTerminals,
    setProcessorTerminalID,
    setKeysData,
    updateProcessorTermSeq,
    setClone,
    setMerchantID,
    fetchTerminalBatchData,
    setTerminalID
}


export default connect(mapStateToProps, mapDispatchToProps)(ProcessorTerminalProfile);